import "./OverdueTasks.css";

import { ImageButton } from "../../layout/ExpandableCard/components";
import { OverdueTask } from "./components/OverdueTask";

type OverdueTasksVariant = "default" | "dashboard";
interface OverdueTasksProps {
  amount: string;
  label: string;
  onViewAll?: () => void;
  variant?: OverdueTasksVariant;
}

export const OverdueTasks = ({ amount, label, onViewAll, variant = "default" }: OverdueTasksProps): JSX.Element => {
  switch (variant) {
    case "dashboard":
      return (
        <div className={`OverdueTasks ${variant}`}>
          <OverdueTask amount={amount} label={label} variant={variant} />
        </div>
      );
    default:
      return (
        <div className="OverdueTasks">
          <div className="OverdueTasksHeader">
            <p className="body01">Tasks</p>
            <div className="AllOverdueTasks">
              <ImageButton linkText="View all" icon="View All" onClick={onViewAll} />
            </div>
          </div>
          <OverdueTask amount={amount} label={label} variant={variant} />
        </div>
      );
  }
};
